const Htmldata = [

    {
        dataid: "mbeT8mpmtHA",
        datatitle: "HTML Basics",
    },

    {
        dataid: "YwbIeMlxZAU",
        datatitle: "HTML Forms"
    },

    {
        dataid: "D3iEE29ZXRM",
        datatitle: "CSS Basics"
    },

    {
        dataid: "FHZn6706e3Q",
        datatitle: "CSS Classes & Selectors"
    },

    {
        dataid: "kGW8Al_cga4",
        datatitle: "HTML 5 Semantics"
    },

    {
        dataid: "25R1Jl5P7Mw",
        datatitle: "Chrome Dev Tools"
    },

    {
        dataid: "XQaHAAXIVg8",
        datatitle: "CSS Layout & Position"
    },

    {
        dataid: "FMu2cKWD90g",
        datatitle: "Pseudo Classes & Elements"
    },

    {
        dataid: "Xig7NsIE6DI",
        datatitle: "Intro to Media Queries"
    },
];

const nodedata = [{ dataid: "rCP9-tP1lRI", datatitle: "What is a server ?" },


{
    dataid: "g64BZXOTGu8"
    , datatitle: "Create your own server using node.js "
},



{ dataid: "1BCYX_nIJOc", datatitle: "What are status codes ? " },


{
    dataid: "G4yky2e7gDo"
    , datatitle: "Implementing status code in server "
},



{
    dataid: "U4cSHAaL34k"
    , datatitle: "Understanding all about NPM and package.json"
},


{ dataid: "abxecsJKPcQ", datatitle: "Intro to Express " },


{ dataid: "BpbFGrZmp2o", datatitle: "What are HTTP methods ? " },


{
    dataid: "nwKYCqwb-OI"
    , datatitle: "Understanding URL Parameters and Queries "
},


{
    dataid: "YsxHx1-lVbM"
    , datatitle: "What is an API  Understanding REST API "
},

{ dataid: "Lb3kEP-FZrA", datatitle: "Mounting in Express " },

{ dataid: "uPFsZLfJ6p0", datatitle: "Creating a SignUp form " },

{ dataid: "QWnaF7HZHJg", datatitle: "What is a Middleware in Express " },

{ dataid: "vkEx-ykOwaY", datatitle: "Introduction to MongoDB " },


{ dataid: "LMnFf0gfuPk", datatitle: "Setting up MongoDB and mongoose  " },


{ dataid: "v3jNZArVY3o", datatitle: "Learning CRUD operations" },


{ dataid: "NDdrLMh-lpQ", datatitle: "What are hooks in Mongoose ?" },


{ dataid: "tEmaZdAbaa0", datatitle: "Learning all about Hashing " },


{ dataid: "TsbrGRnIGZE", datatitle: "Learning cookies " },


{ dataid: "RZbumzj9m7c", datatitle: "Ceating login function" },

{ dataid: "ZWT93NrkCP4", datatitle: "Learning Protect Route " },


{ dataid: "tiok_PF17S4", datatitle: "What is JWT ? " },


{ dataid: "3SZIgZltGac", datatitle: "Introduction to MVC architecture " },


{ dataid: "7yrxyTe8yQ8", datatitle: "Implementing user operations " },


{ dataid: "t5LG2azm15I", datatitle: "Implementing auth operations " },


{
    dataid: "ernepNFOVX8"
    , datatitle: "Using Postman on user and auth functions "
},


{
    dataid: "mhs2cog3RV8"
    , datatitle: "Implementing Forget & Reset password functions"
},


{
    dataid: "IHWGVHiA31o"
    , datatitle: "Attaching methods in mongoose Schema"
},


{ dataid: "KPVVQjesiQQ", datatitle: "Implementing logout  " },


{ dataid: "LofR7Vhxtf4", datatitle: "Creating schema for plans" },


{ dataid: "AnfsWKmXMgM", datatitle: "Creating routes for plans " },

{ dataid: "M2a_c_iR-8E", datatitle: "Implementing controller for plans " },
{ dataid: "b-8lgzjPBSE", datatitle: "Using Postman on plan functions " },


{ dataid: "_bfNQOn8vAc", datatitle: "Creating schema for review" },

{ dataid: "xUwIuJnRbTk", datatitle: "Creating routes for review " },

{
    dataid: "uIXIHHiw7Fc"
    , datatitle: "Implementing controller for review"
},

{ dataid: "wYqWWa4UF4U", datatitle: "Using Postman on review functions" },

{ dataid: "ASqd71bVhLM", datatitle: "Using Stripe API for payments " },

{
    dataid: "o2glGZpOtkA"
    , datatitle: "What is multer ? | Multer in Express"
},


{ dataid: "EPmT-MogFp8", datatitle: "Sending email via Nodemailer" },

{ dataid: "j4rlFpaKq-M", datatitle: "What is CORS ?" },

{
    dataid: "fWYZjNGIXhc"
    , datatitle: "Integration of frontend with backend"
},


{ dataid: "xRHLcGvZPrQ", datatitle: "Website hosting using Heroku" },

{
    dataid: "AhKKov7c1M0"
    , datatitle: "Instagram reels database design and implementation "
},

{
    dataid: "uSIFYZU91YU"
    , datatitle: "Instagram  Backend Development  Login"
},


{
    dataid: "5YUzHwNkLIs"
    , datatitle: "Instagram Backend Development Signup"
},


{
    dataid: "Ab9_N_Gii10"
    , datatitle: " Instagram Backend Development Posts"
},

{
    dataid: "L9z5d_fBsro"
    , datatitle: " Instagram Backend Development Middleware"
},

{
    dataid: "bb61tpUWNWk"
    , datatitle: " Instagram Backend Development Likes"
},


{
    dataid: "wsXaz4cYqW4"
    , datatitle: "Instagram Backend Development Comments"
},


{
    dataid: "nYvbE0tgf0k"
    , datatitle: "Instagram Backend Development Friend Requests"
},

{ dataid: "a0lYL_rrSC8", datatitle: "The Brain of Node JS " },

{ dataid: "DfIfgd9TjB4", datatitle: "Streams in Node Js" },


{ dataid: "nZFPc8uak5s", datatitle: "Node Js Interview Questions " },


{
    dataid: "NvXOWz0OV6Y"
    , datatitle: "SetImmediate SetTimeout and Process.nextTick "
},


{ dataid: "JjOvDXe8-jQ", datatitle: "Child Process Module in Node JS" },


{ dataid: "p1P61dMpVtw", datatitle: "Event Emitter " },


{ dataid: "xpCeM5ygQxQ", datatitle: "Polyfill Of Event Emitter " },


{ dataid: "5kP9D3FRKLg", datatitle: "How Web Works" },


{ dataid: "VkFCjs_rFoI", datatitle: "Export Require" },


{ dataid: "d74bv8WSTWE", datatitle: "Http Module in Node JS " },

];

const Reactdata = [{ dataid: "kVeOpcw4GWY", datatitle: "Creating a React Application" },



{ dataid: "9D1x7-2FmTA", datatitle: "Components & Templates" },


{ dataid: "pnhO8UaCgxg", datatitle: "Dynamic Values in Templates" },




{ dataid: "0sSYmRImgRY", datatitle: "Multiple Components" },



{ dataid: "NbTrGcz4DW8", datatitle: "Adding Styles" },


{ dataid: "0XSDAup85SA", datatitle: "Click Events" },

{ dataid: "4pO-HcG2igk", datatitle: "PUsing State (useState hook)" },


{ dataid: "rb1GWqCJid4", datatitle: " Intro to React Dev Tools" },

{ dataid: "tHjxSVaj_wY", datatitle: " Outputting Lists" },


{ dataid: "PHaECbrKgs0", datatitle: "  Props" },

{ dataid: "-YpnB-zlkPU", datatitle: " Reusing Components" },

{ dataid: "CWEOYFzgOJs", datatitle: " Functions as Props" },

{ dataid: "gv9ugDJ1ynU", datatitle: " useEffect Hook (the basics)" },


{ dataid: "jQc_bTFZ5_I", datatitle: "  useEffect Dependencies" },

{ dataid: "eao7ABGFUXs", datatitle: " Using JSON Server" },


{ dataid: "qdCHEUaFhBk", datatitle: " Fetching Data with useEffect" },


{ dataid: "qtheqr0jgIQ", datatitle: " Conditional Loading Message" },


{ dataid: "DTBta08fXGU", datatitle: " Handling Fetch Errors" },

{ dataid: "Jl4q2cccwf0", datatitle: " Making a Custom Hook" },


{ dataid: "aZGzwEjZrXc", datatitle: " The React Router" },

{ dataid: "EmUa_tcSM-k", datatitle: " Exact Match Routes" },


{ dataid: "DO-pSysGItQ", datatitle: " Router Links" },

{ dataid: "aKOQtGLT-Yk", datatitle: " useEffect Cleanup" },


{ dataid: "t7VmF4WsLCo", datatitle: " Route Parameters" },


{ dataid: "c-5VXl8yPQA", datatitle: " Reusing Custom Hooks" },


{ dataid: "IkMND33x0qQ", datatitle: " Controlled Inputs (forms)" },

{ dataid: "pJiRj02PkJQ", datatitle: " Submit Events" },


{ dataid: "EcRFYF4B3IQ", datatitle: " Making a POST Request" },

{ dataid: "TmVqwhBUiSM", datatitle: " Programmatic Redirects" },


{ dataid: "Wb-0CkLiyQk", datatitle: " Deleting Blogs" }
];
export { Htmldata, nodedata, Reactdata };